import axiosForGigbaseBiz from '../config'

const resource = 'trackings'

export const requests = {
  trackSignin: () => {
    return axiosForGigbaseBiz.post(`${resource}/signin`)
  },
}
